import React from "react";
import { createRoot } from "react-dom/client";

import "../view.css";
import AnalyseForm from "./analyse-form";

document.addEventListener("DOMContentLoaded", function () {
	const element = document.getElementById("react-app");
	if (!element) {
		return;
	}
	const root = createRoot(element);
	root.render(<AnalyseForm />);
});
